<template>
  <main class="main_home">
    <OrganismsIndex />

    <PartsLayoutContainer>
      <PartsLayoutCol2>
        <template #sidebar>
          <OrganismsLayoutsSidebar />
        </template>

        <OrganismsIndexNews />
        <OrganismsIndexTrouble />
        <OrganismsIndexProducts />
        <OrganismsIndexVoice />
        <OrganismsIndexColumn />
      </PartsLayoutCol2>
    </PartsLayoutContainer>
  </main>

  <OrganismsSupport />
</template>

<script setup lang="ts">
/**
 * トップページ。支給デザイン `index.html` の `main.main_home` に対応する。
 *
 * FV は `.container` の外（全幅）、それ以降は `.container > .col2-wrapper` の2カラムに入る。
 * 各セクションは部品側が `section` ごと持つので、ここは並べるだけにする。
 *
 * 末尾の `OrganismsSupport` はサポート導線の4コンテンツ。**ルートごとに載せる載せないが決まる**ため
 * `layouts/default.vue` ではなくページ側に置く（CONVERSION-GUIDE §6「サポート導線4コンテンツ」）。
 * **`<main>` の外に置くこと。支給が `</main>` の後ろに出しているのに従う。** `main` には
 * `max-width: 1200px` ＋ `background-color: var(--white)`（`renewal/style.css:99-104`）が掛かるので、
 * 中に入れると**全幅グレー帯が 1200px で切れて左右に白が残る**（#1262 レビューで指摘）。
 *
 * 旧デザインの `l-main` / `p-top` / `l-2column` は付けない。旧CSSの指定を持ち込まないため。
 */
import { DEFAULT_DESCRIPTION } from '@/consts/SeoConst';
useSeoMeta({
  title: 'オリエンタルバイオ公式オンラインショップ',
  description: DEFAULT_DESCRIPTION,
  keywords:
    'オリエンタルバイオ,大豆発酵エキスNT,小林式EPA ,K-2乳酸菌,植物性ラクトバチルス乳酸菌,ラフィーネ-アルファ,ラフィーネアルファ,ラフィーネエパゴールド,アレルナイト,アレルナイトプラス,ケンコス,KENCOS,エニスト,NST,健康食品,サプリメント,健康グッズ,スキンケア,公式,通販',
});
</script>
